import { useStaticQuery, graphql } from 'gatsby';
export const deleteMe = {};

// TODO: when we have data sourced to Gatsby we'll need to update these queries to match Gatsby's filtering
// export const useSubscriptionProductsStaticQuery = () => {
//   const data = useStaticQuery(
//     graphql`
//       query SubscriptionProducts {
//         standardSubscriptions: products(collection_title: "Subscriptions", sku_filter: "standard") {
//           ...ProductFields
//         }
//         athleteSubscriptions: products(collection_title: "Subscriptions", sku_filter: "athlete") {
//           ...ProductFields
//         }
//       }
//     `
//   );
//   return data;
// };

// export const useMealProductsStaticQuery = () => {
//   const data = useStaticQuery(
//     graphql`
//       query MealProducts {
//         standardMeals: products(collection_title: "Meals", sku_filter: "standard") {
//           ...ProductFields
//         }
//         athleteMeals: products(collection_title: "Meals", sku_filter: "athlete") {
//           ...ProductFields
//         }
//       }
//     `
//   );
//   return data;
// };
